// extracted by mini-css-extract-plugin
export default {"container":"forbidden-message_container__yrEU-"};